import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { resetRouter } from '@/router/router';
import { mapGetters, mapState } from "vuex";
import { fullscreenToggel, listenfullscreen, setTheme } from "@/util/util";
import topLock from "./top-lock";
import topMenu from "./top-menu";
import topSearch from "./top-search";
import topTheme from "./top-theme";
import topLogs from "./top-logs";
import topColor from "./top-color";
import topNotice from "./top-notice";
import topLang from "./top-lang";
import color from "@/mixins/color";
export default {
  components: {
    topLock: topLock,
    topMenu: topMenu,
    topSearch: topSearch,
    topTheme: topTheme,
    topLogs: topLogs,
    topColor: topColor,
    topNotice: topNotice,
    topLang: topLang
  },
  name: "top",
  mixins: [color()],
  data: function data() {
    return {
      companyTitle: ''
    };
  },
  filters: {},
  created: function created() {},
  mounted: function mounted() {
    listenfullscreen(this.setScreen);
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    showDebug: function showDebug(state) {
      return state.common.showDebug;
    },
    showTheme: function showTheme(state) {
      return state.common.showTheme;
    },
    showLock: function showLock(state) {
      return state.common.showLock;
    },
    showFullScren: function showFullScren(state) {
      return state.common.showFullScren;
    },
    showCollapse: function showCollapse(state) {
      return state.common.showCollapse;
    },
    showSearch: function showSearch(state) {
      return state.common.showSearch;
    },
    showMenu: function showMenu(state) {
      return state.common.showMenu;
    },
    showColor: function showColor(state) {
      return state.common.showColor;
    }
  })), mapGetters(["userInfo", "isFullScren", "tagWel", "tagList", "isCollapse", "tag", "logsLen", "logsFlag"])),
  methods: {
    handleScreen: function handleScreen() {
      fullscreenToggel();
    },
    setCollapse: function setCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    setScreen: function setScreen() {
      this.$store.commit("SET_FULLSCREN");
    },
    resetTheme: function resetTheme() {
      // console.log(this,'afafdsaf---')
      // this.$store.commit("SET_THEME_NAME", 'theme-default');
      // setTheme('theme-default');
      this.$refs.modifyColor.themeVal = '#1E90FF';
      this.$refs.theme.text = 'theme-vip';
    },
    logout: function logout() {
      var _this = this;

      this.$confirm(this.$t("logoutTip"), this.$t("tip"), {
        confirmButtonText: this.$t("submitText"),
        cancelButtonText: this.$t("cancelText"),
        type: "warning"
      }).then(function () {
        _this.$store.dispatch("LogOut").then(function () {
          resetRouter();

          _this.$router.push({
            path: "/login"
          });
        });
      });
    }
  }
};